module.exports = __webpack_public_path__ + "static/img/DeluxeDoubleRoom4.ccbf6004.jpg";